import React from 'react';
import Header from './Header';
import Footer from './Footer';
import './ProductsPage.css'; // For products list only, not for product detail
import { useNavigate, Link } from 'react-router-dom';

const products = [
  {
    id: 'chroniq',
    image: '/logo_chroniq.png',
    title: 'Chroniq: Listen to the Past Come Alive',
    rating: 0,
    category: 'Education',
    developer: '',
    isPWA: true,
  },
  {
    id: 'sipless',
    image: '/logo_sipless.webp',
    title: 'Sipless: Sobriety Tracker',
    rating: 0,
    category: 'Lifestyle',
    developer: '',
    isPWA: false,
  },
];

const ProductsPage = () => {
  return (
    <div className="products-page">
      <Header />
      <main className="products-main">
        <h1 className="products-title">Best applications you could ever imagine</h1>
        <div className="products-content-row">
          <div className="products-list">
            {products.map((product, idx) => (
              <div className="product-card" key={idx}>
                <Link to={`/product/${product.id}`} className="product-card-link">
                  <div className="product-image-and-title">
                    <div className="product-image">
                      <img src={product.image} alt={product.title} />
                    </div>
                    <div className="product-title">{product.title}</div>
                  </div>
                  {
                    <div className="product-meta-right">
                      <div className="product-meta-block">
                        <div className="product-meta-label">Category</div>
                        <div className="product-meta-value">{product.category}</div>
                      </div>
                    </div>
                  }
                </Link>
              </div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ProductsPage;
